"use client"

import { CheckCircle2 } from "lucide-react"

interface TimelineEvent {
  year: number
  title: string
  description: string
  milestone: string
}

interface TimelineProps {
  events: TimelineEvent[]
}

export function Timeline({ events }: TimelineProps) {
  return (
    <div className="relative">
      {/* Vertical Line */}
      <div className="absolute left-1/2 -translate-x-1/2 w-1 h-full bg-gradient-to-b from-primary to-accent top-0" />

      {/* Events */}
      <div className="space-y-12">
        {events.map((event, idx) => (
          <div key={idx} className={`flex gap-8 ${idx % 2 === 0 ? "flex-row" : "flex-row-reverse"}`}>
            {/* Content */}
            <div className={`flex-1 ${idx % 2 === 0 ? "text-right" : "text-left"}`}>
              <div className="p-6 bg-card rounded-lg border border-border hover:border-primary/50 transition-colors">
                <div className="text-3xl font-bold text-primary mb-2">{event.year}</div>
                <h3 className="text-xl font-bold text-foreground mb-2">{event.title}</h3>
                <p className="text-foreground/70 mb-3">{event.description}</p>
                <div className="inline-block px-3 py-1 bg-primary/10 text-primary text-sm font-semibold rounded-full">
                  {event.milestone}
                </div>
              </div>
            </div>

            {/* Circle Node */}
            <div className="flex-shrink-0 flex items-center justify-center">
              <div className="w-12 h-12 rounded-full bg-background border-4 border-primary flex items-center justify-center">
                <CheckCircle2 size={20} className="text-primary" />
              </div>
            </div>

            {/* Empty Space */}
            <div className="flex-1" />
          </div>
        ))}
      </div>
    </div>
  )
}
